webpackJsonp([16],{

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(490),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-36827d5a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(272);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("c47d271c", content, true, {});

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".welcome{padding:32px 22px;position:absolute;inset:0;display:flex;flex-direction:column;gap:24px}.welcome h2{font:var(--huge-font);margin-top:20px}.welcome h3{font:var(--huge-font);text-align:center}.welcome .textbox{color:#19181e;font-size:20px}.welcome svg{overflow:visible}.welcome .lockbreak{width:30px}.welcome .register-text{font-size:24px;margin-bottom:20px;text-align:center}.welcome .package-details{font-size:20px}.welcome .subtitle{font-size:26px;margin-bottom:24px}.welcome .icon{width:30px;padding-bottom:10px}.welcome .line{display:flex;margin:10px 20px;align-items:center;gap:10px}.welcome .program-option{height:fit-content;border:1px solid #000;border-radius:5px;display:flex;align-items:center;justify-content:space-between;margin:10px 0;padding:16px 28px}.welcome .bestOption{position:relative;padding-top:20px}.welcome .chosenOption{background-color:#555fff;color:#fff;outline:3px solid #119}.welcome span{font:var(--medium-font)}.welcome .recomanded{background-color:#119;color:#fff;font:var(--tiny-font);position:absolute;top:0;right:0px;border-bottom-left-radius:11px;padding:0px 5px}.welcome .takanon{width:100%;background-color:#fff;border:#a6a6d9 1px solid;height:100px;overflow:scroll;margin:5px auto;padding:3px}.welcome .takanon p{font:var(--small-font)}.welcome .confirm{background-color:var(--bg-primary);border:#a6a6d9 1px solid;height:100px;overflow:scroll;border-radius:5px;margin:70px auto 10px;padding:8px}.welcome .confirm p{font:var(--small-font)}.welcome .submit-payment{display:flex;justify-content:center}.welcome .submit-payment button{width:100%;height:58px;border-radius:5px;background-color:var(--button-primary);color:var(--button-primary-text);margin:auto;font:var(--large-font)}.welcome .takanon-text{font:var(--small-font)}.modal-container{position:fixed;z-index:1000;width:100%;left:0;top:0;background-color:rgba(0,0,0,.4);height:100%}.modal-content{background:var(--bg-primary);height:fit-content;text-align:center;padding:5%;border-radius:5px}.fullBtn{color:var(--button-primary-text);font:var(--medium-font);width:100%;border-radius:8px;background-color:var(--button-primary);height:60px;display:flex;justify-content:center;align-items:center;gap:8px}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/components/Shared/style.scss"],"names":[],"mappings":"AAAA,SACE,kBACA,kBACA,QACA,aACA,sBACA,QAAA,CAEA,YACE,sBACA,eAAA,CAGF,YACE,sBACA,iBAAA,CAGF,kBACE,cACA,cAAA,CAGF,aACE,gBAAA,CAGF,oBACE,UAAA,CAGF,wBACE,eACA,mBACA,iBAAA,CAGF,0BACE,cAAA,CAGF,mBACE,eACA,kBAAA,CAGF,eACE,WACA,mBAAA,CAGF,eACE,aACA,iBACA,mBACA,QAAA,CAGF,yBACE,mBACA,sBAEA,kBACA,aACA,mBACA,8BACA,cACA,iBAAA,CAGF,qBACE,kBACA,gBAAA,CAGF,uBACE,yBACA,WACA,sBAAA,CAGF,cACE,uBAAA,CAGF,qBACE,sBACA,WACA,sBACA,kBACA,MACA,UACA,+BACA,eAAA,CAGF,kBACE,WACA,sBACA,yBACA,aACA,gBACA,gBACA,WAAA,CAEA,oBACE,sBAAA,CAIJ,kBACE,mCACA,yBACA,aACA,gBACA,kBACA,sBACA,WAAA,CAEA,oBACE,sBAAA,CAIJ,yBACE,aACA,sBAAA,CAEA,gCACE,WACA,YACA,kBACA,uCAEA,iCACA,YACA,sBAAA,CAIJ,uBACE,sBAAA,CAIJ,iBACE,eACA,aACA,WACA,OACA,MACA,gCACA,WAAA,CAGF,eACE,6BACA,mBACA,kBACA,WACA,iBAAA,CAGF,SACE,iCACA,wBACA,WACA,kBACA,uCACA,YACA,aACA,uBACA,mBACA,OAAA,CAAA","file":"style.scss","sourcesContent":[".welcome {\n  padding: 32px 22px;\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  h2 {\n    font: var(--huge-font);\n    margin-top: 20px;\n  }\n\n  h3 {\n    font: var(--huge-font);\n    text-align: center;\n  }\n\n  .textbox {\n    color: #19181e;\n    font-size: 20px;\n  }\n\n  svg {\n    overflow: visible;\n  }\n\n  .lockbreak {\n    width: 30px;\n  }\n\n  .register-text {\n    font-size: 24px;\n    margin-bottom: 20px;\n    text-align: center;\n  }\n\n  .package-details {\n    font-size: 20px;\n  }\n\n  .subtitle {\n    font-size: 26px;\n    margin-bottom: 24px;\n  }\n\n  .icon {\n    width: 30px;\n    padding-bottom: 10px;\n  }\n\n  .line {\n    display: flex;\n    margin: 10px 20px;\n    align-items: center;\n    gap: 10px;\n  }\n\n  .program-option {\n    height: fit-content;\n    border: 1px solid black;\n    // width: 100%;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 10px 0;\n    padding: 16px 28px;\n  }\n\n  .bestOption {\n    position: relative;\n    padding-top: 20px;\n  }\n\n  .chosenOption {\n    background-color: #555fff;\n    color: #fff;\n    outline: 3px solid #111199;\n  }\n\n  span {\n    font: var(--medium-font);\n  }\n\n  .recomanded {\n    background-color: #111199;\n    color: white;\n    font: var(--tiny-font);\n    position: absolute;\n    top: 0;\n    right: 0px;\n    border-bottom-left-radius: 11px;\n    padding: 0px 5px;\n  }\n\n  .takanon {\n    width: 100%;\n    background-color: white;\n    border: #a6a6d9 1px solid;\n    height: 100px;\n    overflow: scroll;\n    margin: 5px auto;\n    padding: 3px;\n\n    p {\n      font: var(--small-font);\n    }\n  }\n\n  .confirm {\n    background-color: var(--bg-primary);\n    border: #a6a6d9 1px solid;\n    height: 100px;\n    overflow: scroll;\n    border-radius: 5px;\n    margin: 70px auto 10px;\n    padding: 8px;\n\n    p {\n      font: var(--small-font);\n    }\n  }\n\n  .submit-payment {\n    display: flex;\n    justify-content: center;\n\n    button {\n      width: 100%;\n      height: 58px;\n      border-radius: 5px;\n      background-color: var(--button-primary);\n\n      color: var(--button-primary-text);\n      margin: auto;\n      font: var(--large-font);\n    }\n  }\n\n  .takanon-text {\n    font: var(--small-font);\n  }\n}\n\n.modal-container {\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  left: 0;\n  top: 0;\n  background-color: rgba(0, 0, 0, 0.4);\n  height: 100%;\n}\n\n.modal-content {\n  background: var(--bg-primary);\n  height: fit-content;\n  text-align: center;\n  padding: 5%;\n  border-radius: 5px;\n}\n\n.fullBtn {\n  color: var(--button-primary-text);\n  font: var(--medium-font);\n  width: 100%;\n  border-radius: 8px;\n  background-color: var(--button-primary);\n  height: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(486);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("30fd1fc5", content, true, {});

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.iframe-container[data-v-36827d5a] {\n  text-align: center;\niframe {\n    height: 50vh;\n}\n}\n.content-container[data-v-36827d5a] {\n  height: 50vh;\n  margin-bottom: 5vh;\n}\n.ignore-container[data-v-36827d5a] {\n  text-align: center;\n.ignore-button {\n    color: var(--button-primary);\n    font-size: 18px;\n}\n}\n#addToHomeScreenModal[data-v-36827d5a] {\n  z-index: 99999999;\n  padding: 36px 32px 24px 32px;\n  margin: auto;\n  border-radius: 8px;\n  width: calc(100vw - 36px);\n  max-width: 328px;\n}\n#addToHomeScreenModal[data-v-36827d5a]::-webkit-backdrop {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n#addToHomeScreenModal[data-v-36827d5a]::backdrop {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n.actions-wrapper[data-v-36827d5a] {\n  margin-top: auto;\n}\n.close-button[data-v-36827d5a] {\n  position: absolute;\n  right: 12;\n  font-size: 16px;\n  position: absolute;\n  right: 14px;\n  top: 12px;\n}\n.title[data-v-36827d5a] {\n  margin-top: 12px;\n  line-height: 1.5 !important;\n  font-size: 28px !important;\n  font-weight: bold;\n  font-family: fredoka !important;\n}\n.modal-content[data-v-36827d5a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\np[data-v-36827d5a] {\n  font-size: 16px;\n  margin-top: 24px;\n}\n.modal-button[data-v-36827d5a] {\n  font-size: 18px;\n  font-weight: bold;\n  background: var(--button-primary);\n  color: var(--button-primary-text);\n  padding: 8px 18px;\n  border-radius: 8px;\n  width: 100%;\n  height: 48px;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/AddToHomeScreen/AddToHomeScreen.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;AACrB;IACI,aAAa;CAChB;CACA;AACD;EACE,aAAa;EACb,mBAAmB;CACpB;AACD;EACE,mBAAmB;AACrB;IACI,6BAA6B;IAC7B,gBAAgB;CACnB;CACA;AACD;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;CAClB;AACD;EACE,qCAAqC;CACtC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,iBAAiB;CAClB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,UAAU;CACX;AACD;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,gCAAgC;CACjC;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;CAC7B;AACD;EACE,gBAAgB;EAChB,iBAAiB;CAClB;AACD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;CACd","file":"AddToHomeScreen.vue","sourcesContent":["\n.iframe-container[data-v-36827d5a] {\n  text-align: center;\niframe {\n    height: 50vh;\n}\n}\n.content-container[data-v-36827d5a] {\n  height: 50vh;\n  margin-bottom: 5vh;\n}\n.ignore-container[data-v-36827d5a] {\n  text-align: center;\n.ignore-button {\n    color: var(--button-primary);\n    font-size: 18px;\n}\n}\n#addToHomeScreenModal[data-v-36827d5a] {\n  z-index: 99999999;\n  padding: 36px 32px 24px 32px;\n  margin: auto;\n  border-radius: 8px;\n  width: calc(100vw - 36px);\n  max-width: 328px;\n}\n#addToHomeScreenModal[data-v-36827d5a]::-webkit-backdrop {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n#addToHomeScreenModal[data-v-36827d5a]::backdrop {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n.actions-wrapper[data-v-36827d5a] {\n  margin-top: auto;\n}\n.close-button[data-v-36827d5a] {\n  position: absolute;\n  right: 12;\n  font-size: 16px;\n  position: absolute;\n  right: 14px;\n  top: 12px;\n}\n.title[data-v-36827d5a] {\n  margin-top: 12px;\n  line-height: 1.5 !important;\n  font-size: 28px !important;\n  font-weight: bold;\n  font-family: fredoka !important;\n}\n.modal-content[data-v-36827d5a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\np[data-v-36827d5a] {\n  font-size: 16px;\n  margin-top: 24px;\n}\n.modal-button[data-v-36827d5a] {\n  font-size: 18px;\n  font-weight: bold;\n  background: var(--button-primary);\n  color: var(--button-primary-text);\n  padding: 8px 18px;\n  border-radius: 8px;\n  width: 100%;\n  height: 48px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_style_scss__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Shared_style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddToHomeScreen_scss__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddToHomeScreen_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AddToHomeScreen_scss__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      userPlatform: "", // 'desktop', 'android', 'ios'
      showAndroidAutomat: false,
      showAndroidManual: false,
      showiOSModal: false,
      deferredPrompt: null,
      isLoading: true
    };
  },

  watch: {
    deferredPrompt: function deferredPrompt() {
      if (this.userPlatform === "desktop" || this.userPlatform === "android") {
        this.handleAndriond();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.userPlatform = _this.detectPlatform();
      console.log(_this.userPlatform + " platform detected.");

      if (_this.userPlatform === "ios") {
        _this.handleIOS();
      } else if (_this.userPlatform === "desktop" || _this.userPlatform === "android") {
        _this.handleEvent();
      }
    });
  },

  methods: {
    detectPlatform: function detectPlatform() {
      var userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.includes("android")) {
        return "android";
      } else if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
        return "ios";
      } else {
        return "desktop";
      }
    },
    handleEvent: function handleEvent() {
      var _this2 = this;

      window.addEventListener("beforeinstallprompt", function (event) {
        event.preventDefault();
        _this2.deferredPrompt = event;
      });
      if (this.deferredPrompt == null) {
        this.deferredPrompt = false;
      }
    },
    handleAndriond: function handleAndriond() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var addedToHomeScreen;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.isLoading = false;
                addedToHomeScreen = localStorage.getItem("addedToHomeScreen");

                if (_this3.deferredPrompt) {
                  _this3.showAndroidManual = false;
                  _this3.showAndroidAutomat = true;
                } else if (!addedToHomeScreen) {
                  _this3.showAndroidManual = true;
                } else {
                  _this3.goHome();
                }
                //  Workaround to push credentials to cache for IOS users on PWA

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    handleIOS: function handleIOS() {
      this.isLoading = false;
      var addedToHomeScreen = localStorage.getItem("addedToHomeScreen");

      caches.open("auth").then(function (cache) {
        return cache.put("/refresh", new Response(localStorage.engrefresh));
      });
      if (!addedToHomeScreen) {
        this.showiOSModal = true;
      }
    },
    ignoreHomeScreen: function ignoreHomeScreen() {
      localStorage.setItem("addedToHomeScreen", "true");
      this.goHome();
    },
    addToHomeScreen: function addToHomeScreen() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var results;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.deferredPrompt.prompt();
                _context2.next = 3;
                return _this4.deferredPrompt.userChoice;

              case 3:
                results = _context2.sent;

                if (results.outcome == "accepted") {
                  localStorage.setItem("addedToHomeScreen", "true");
                  _this4.goHome();
                } else {
                  _this4.$forceUpdate();
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    confirmiOSAdded: function confirmiOSAdded() {
      localStorage.setItem("addedToHomeScreen", "true");
      this.goHome();
    },
    goHome: function goHome() {
      this.$router.push({ path: "/", query: this.$route.query });
    }
  }
});

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(489);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("715cc1e4", content, true, {});

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".content-container{text-align:center}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/AddToHomeScreen/src/components/AddToHomeScreen/AddToHomeScreen.scss"],"names":[],"mappings":"AAAA,mBACE,iBAAA,CAAA","file":"AddToHomeScreen.scss","sourcesContent":[".content-container {\n  text-align: center;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 490:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "welcome"
  }, [(_vm.isLoading) ? _c('div') : _c('div', [_c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("addToHomeScreen.install_app")) + "\n        ")])]), _vm._v(" "), _c('div', [(_vm.showiOSModal) ? _c('div', {
    staticClass: "content-container"
  }, [_c('iframe', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": "https://www.youtube.com/embed/TMX46ia6i_4",
      "title": "YouTube video player",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      "allowfullscreen": ""
    }
  })]) : (_vm.showAndroidManual) ? _c('div', {
    staticClass: "content-container"
  }, [_c('iframe', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": "https://www.youtube.com/embed/OPRrk5oXXCY",
      "title": "YouTube video player",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      "allowfullscreen": ""
    }
  })]) : (_vm.showAndroidAutomat) ? _c('div', {
    staticClass: "content-container"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "actions-wrapper"
  }, [(_vm.showAndroidAutomat) ? _c('div', {
    staticClass: "fullBtn",
    on: {
      "click": _vm.addToHomeScreen
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("addToHomeScreen.add_to_homescreen")) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.showiOSModal || _vm.showAndroidManual) ? _c('div', {
    staticClass: "fullBtn",
    on: {
      "click": _vm.confirmiOSAdded
    }
  }, [_c('button', [_vm._v(_vm._s(_vm.$t("addToHomeScreen.saw_video")))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ignore-container"
  }, [_c('p', {
    staticClass: "ignore-button",
    on: {
      "click": _vm.ignoreHomeScreen
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("addToHomeScreen.dont_install")) + "\n          ")])])])])])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// 16.ce03fd3d81a126f24b18.bundle.js